import PropTypes from "prop-types";
import "app/pages/.shared/Page/page.scss";

const Page = ({ title, children }) => {
	return (
		<div className="page">
			<h3 className="page__title">{title}</h3>
			<section className="page__content">{children}</section>
		</div>
	);
};

Page.propTypes = {
	title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
};

export default Page;
